var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"redirect-if-no-permission",rawName:"v-redirect-if-no-permission:BOOKINGS",arg:"BOOKINGS"}]},[_c('v-layout',{staticStyle:{"background-color":"white"},attrs:{"justify-end":""}},[_c('div'),_c('v-select',{staticStyle:{"max-width":"250px"},attrs:{"items":_vm.items,"item-text":"value","item-value":"key","label":_vm.$t('reservationsPage.logActionType')},on:{"change":_vm.typeFilter},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}})],1),_c('DataTable',{attrs:{"url":_vm.api.ACTIONS.BOOKING_LOG(_vm.$route.params.id),"appends":['status'],"initial-url-search-params":_vm.requestType,"fields-hidden-main":[
      'deleted_at',
      'updated_at',
      'entity',
      'entity_type',
      'id',
      'entity_id',
      'requester_captain_id',
      'receiver_captain_id',
      'requester_booking_id',
      'requester_captain',
      'receiver_captain',
      'receiver_booking_id',
      'expired_time',
      'booking_id',
      'captain_id',
    ],"disableSearch":true,"enableEdit":false,"enableAdd":false,"enableDelete":false,"titles":_vm.titles,"formatter":_vm.formatters}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }